import { atom } from "recoil";
import { recoilPersist } from "recoil-persist";

const { persistAtom } = recoilPersist();

export const selectBarcodeState = atom({
  key: "selectBarcodeState",
  default: {
    date: "",
    tmdv: "",
    empcd: "",
    tgbran: "",
    pob: "",
    car: "",
    barcode: "",
  },
  effects_UNSTABLE: [persistAtom],
});